import { OverlayLoader } from 'components/Loaders'
import ScrollToTop from 'components/ScrollToTop'
import { actions } from 'data'
import React, { Suspense, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Navigate, Route, Routes } from 'react-router-dom'
import styled from 'styled-components'
import { screenWidth } from 'utils'
import { addTiming } from 'utils/datadog'

import Layout from '../../layouts/Layout'
import { languagePrefixes } from '../../providers/ConnectedIntl/languages'
import Trade from '../Trade/Routes'
import DataDogTracker from './DataDogTracker'
import GoogleAnalyticsTracker from './GoogleAnalyticsTracker'
import OnBootMessages from './OnBootMessages'
import EligibilityNotifications from './OnBootMessages/EligibilityNotifications'
import PollingProducts from './PollingProducts'
import PostMessageListener from './PostMessageListener'
import SessionMonitor from './SessionMonitor'
import Zendesk from './Zendesk'

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  position: relative;
  min-height: 100%;
  min-width: 100%;
  z-index: 0;
  overflow-y: auto;

  @media only screen and (max-width: ${screenWidth('sm')}) {
    overflow-y: hidden;
  }
`

const LazyMarkets = React.lazy(() => import('../Markets'))
const Markets = () => (
  <Suspense fallback={<OverlayLoader />}>
    <LazyMarkets />
  </Suspense>
)

const LazyHistory = React.lazy(() => import('../History'))
const History = () => (
  <Suspense fallback={<OverlayLoader />}>
    <LazyHistory />
  </Suspense>
)

const LazyPortfolio = React.lazy(() => import('../Portfolio'))
const Portfolio = () => (
  <Suspense fallback={<OverlayLoader />}>
    <LazyPortfolio />
  </Suspense>
)

const LazySettings = React.lazy(() => import('../Settings'))
const Settings = () => (
  <Suspense fallback={<OverlayLoader />}>
    <LazySettings />
  </Suspense>
)

const PageRoutes = () => (
  <Routes>
    <Route element={<Markets />} path='market/*' />
    {/*<Route element={<Trade />} path='trade/*' />*/}
    <Route path='trade/*' element={<Navigate to="/market" replace />} />
    <Route element={<History />} path='history/*' />
    <Route element={<Portfolio />} path='portfolio/*' />
    <Route element={<Settings />} path='settings/*' />
  </Routes>
)

const AppContainer = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    performance.mark('AppContainer:mount')
    performance.measure('AppContainer loaded', 'Main:mount', 'AppContainer:mount')
    addTiming('app-container-loaded')

    // Pre-cache user feed so order placing won't be delayed on order confirmation modal
    dispatch(actions.auth.getUserFees())
  }, [])

  return (
    <Wrapper>
      <Layout>
        <ScrollToTop />
        <PostMessageListener />
        <OnBootMessages />
        <EligibilityNotifications />
        <SessionMonitor />
        <Zendesk />
        <DataDogTracker />
        <PollingProducts />
        <GoogleAnalyticsTracker />
        <Routes>
          <Route path='/'>
            {languagePrefixes.map((language) => (
              <Route key={language} path={`${language}/*`} element={<PageRoutes />} />
            ))}
            <Route path='*' element={<PageRoutes />} />
          </Route>
        </Routes>
      </Layout>
    </Wrapper>
  )
}

export default AppContainer
